// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    font-size: 0.875rem;
}

.feather {
    width: 16px;
    height: 16px;
    vertical-align: text-bottom;
}

/*
 * Sidebar
 */

.sidebar {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 100; /* Behind the navbar */
    padding: 48px 0 0; /* Height of navbar */
    box-shadow: inset -1px 0 0 rgba(0, 0, 0, 0.1);
}

@media (max-width: 767.98px) {
    .sidebar {
        top: 5rem;
    }
}

.sidebar-sticky {
    position: relative;
    top: 0;
    height: calc(100vh - 48px);
    padding-top: 0.5rem;
    overflow-x: hidden;
    overflow-y: auto; /* Scrollable contents if viewport is shorter than content. */
}

@supports (position: sticky) {
    .sidebar-sticky {
        position: sticky;
    }
}

.sidebar .nav-link {
    font-weight: 500;
    color: #333;
}

.sidebar .nav-link .feather {
    margin-right: 4px;
    color: #999;
}

.sidebar .nav-link.active {
    color: #007bff;
}

.sidebar .nav-link:hover .feather,
.sidebar .nav-link.active .feather {
    color: inherit;
}

.sidebar-heading {
    font-size: 0.75rem;
    text-transform: uppercase;
}

/*
 * Navbar
 */

.navbar-brand {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    font-size: 1rem;
    background-color: rgba(0, 0, 0, 0.25);
    box-shadow: inset -1px 0 0 rgba(0, 0, 0, 0.25);
}

.navbar .navbar-toggler {
    top: 0.25rem;
    right: 1rem;
}

.navbar .form-control {
    padding: 0.75rem 1rem;
    border-width: 0;
    border-radius: 0;
}

.form-control-dark {
    color: #fff;
    background-color: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.1);
}

.form-control-dark:focus {
    border-color: transparent;
    box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.25);
}

/* Form  */
.form-editor {
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
}

/*
 * Style
 */
.width_200 {
    width: 200px;
}
.width_170 {
    width: 170px;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;;EAEE;;AAEF;IACI,eAAe;IACf,MAAM;IACN,SAAS;IACT,OAAO;IACP,YAAY,EAAE,sBAAsB;IACpC,iBAAiB,EAAE,qBAAqB;IACxC,6CAA6C;AACjD;;AAEA;IACI;QACI,SAAS;IACb;AACJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,0BAA0B;IAC1B,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB,EAAE,6DAA6D;AACnF;;AAEA;IACI;QAEI,gBAAgB;IACpB;AACJ;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;;EAEE;;AAEF;IACI,oBAAoB;IACpB,uBAAuB;IACvB,eAAe;IACf,qCAAqC;IACrC,8CAA8C;AAClD;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,0CAA0C;IAC1C,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;IACzB,+CAA+C;AACnD;;AAEA,UAAU;AACV;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;;EAEE;AACF;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB","sourcesContent":["body {\n    font-size: 0.875rem;\n}\n\n.feather {\n    width: 16px;\n    height: 16px;\n    vertical-align: text-bottom;\n}\n\n/*\n * Sidebar\n */\n\n.sidebar {\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 100; /* Behind the navbar */\n    padding: 48px 0 0; /* Height of navbar */\n    box-shadow: inset -1px 0 0 rgba(0, 0, 0, 0.1);\n}\n\n@media (max-width: 767.98px) {\n    .sidebar {\n        top: 5rem;\n    }\n}\n\n.sidebar-sticky {\n    position: relative;\n    top: 0;\n    height: calc(100vh - 48px);\n    padding-top: 0.5rem;\n    overflow-x: hidden;\n    overflow-y: auto; /* Scrollable contents if viewport is shorter than content. */\n}\n\n@supports ((position: -webkit-sticky) or (position: sticky)) {\n    .sidebar-sticky {\n        position: -webkit-sticky;\n        position: sticky;\n    }\n}\n\n.sidebar .nav-link {\n    font-weight: 500;\n    color: #333;\n}\n\n.sidebar .nav-link .feather {\n    margin-right: 4px;\n    color: #999;\n}\n\n.sidebar .nav-link.active {\n    color: #007bff;\n}\n\n.sidebar .nav-link:hover .feather,\n.sidebar .nav-link.active .feather {\n    color: inherit;\n}\n\n.sidebar-heading {\n    font-size: 0.75rem;\n    text-transform: uppercase;\n}\n\n/*\n * Navbar\n */\n\n.navbar-brand {\n    padding-top: 0.75rem;\n    padding-bottom: 0.75rem;\n    font-size: 1rem;\n    background-color: rgba(0, 0, 0, 0.25);\n    box-shadow: inset -1px 0 0 rgba(0, 0, 0, 0.25);\n}\n\n.navbar .navbar-toggler {\n    top: 0.25rem;\n    right: 1rem;\n}\n\n.navbar .form-control {\n    padding: 0.75rem 1rem;\n    border-width: 0;\n    border-radius: 0;\n}\n\n.form-control-dark {\n    color: #fff;\n    background-color: rgba(255, 255, 255, 0.1);\n    border-color: rgba(255, 255, 255, 0.1);\n}\n\n.form-control-dark:focus {\n    border-color: transparent;\n    box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.25);\n}\n\n/* Form  */\n.form-editor {\n    border: 1px solid #ced4da;\n    border-radius: 0.25rem;\n}\n\n/*\n * Style\n */\n.width_200 {\n    width: 200px;\n}\n.width_170 {\n    width: 170px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
